import React from 'react';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import * as actions from 'actions';
import styles from './overlay.css';

const Overlay = ({ overlay }) => (
  <TransitionGroup>
    {overlay ? (
      <CSSTransition
        timeout={{ enter: 0, exit: 300 }}
        key="overlay"
        classNames={{
          exitActive: styles.exit,
        }}
      >
        <div
          style={{
            backgroundColor: overlay,
          }}
          className={styles.overlay}
        />
      </CSSTransition>
    ) : null}
  </TransitionGroup>
);

const mapStateToProps = state => ({
  overlay: state.overlay,
});

const mapDispatchToProps = dispatch => ({
  closeOverlay: () => dispatch(actions.closeOverlay()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Overlay);



// WEBPACK FOOTER //
// ./src/components/modules/Overlay/Overlay.js